var TickerTimeline = /** @class */ (function () {
    function TickerTimeline(ticker) {
        this._playing = false;
        this._time = 0;
        this.duration = 1000; // time in milliseconds
        this._ticker = ticker;
        this._ticker.add(this._update, this);
    }
    TickerTimeline.prototype.play = function () {
        this._playing = true;
    };
    TickerTimeline.prototype.stop = function () {
        this._playing = false;
        this._time = 0;
    };
    Object.defineProperty(TickerTimeline.prototype, "playing", {
        get: function () {
            return this._playing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TickerTimeline.prototype, "time", {
        get: function () {
            return this._time;
        },
        set: function (value) {
            this._time = value;
        },
        enumerable: false,
        configurable: true
    });
    TickerTimeline.prototype._update = function () {
        if (!this.playing) {
            return;
        }
        this._time += this._ticker.deltaMS;
        if (this._time > this.duration) {
            this._time = 0;
        }
    };
    TickerTimeline.prototype.destroy = function () {
        this._ticker.destroy();
        this._ticker = undefined;
    };
    return TickerTimeline;
}());
export { TickerTimeline };
